import { ModelType } from '@/app/base/schemas/BaseSchema';
import EndpointFactory from '@/app/factories/EndpointFactory';
import Form from '@/classes/Form';

export default async function useSaveSettings(form: Form<any>, displaySuccessMessage: boolean = true) {
    const endpoint = EndpointFactory.make(ModelType.SETTINGS);
    const data = {
        data: {
            type: 'settings',
            attributes: form.data(),
        },
    };

    const response = await form.loadUntil(endpoint.withoutEvents().customAction(null, 'upsert', 'PUT', data));

    if (response.error) {
        useToasteoError();
        return;
    }

    if (displaySuccessMessage) {
        useToasteoSuccess();
    }
}
